import React from 'react';
import { useSearchParams, useLocation, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

/**
 * Landing pages Stripe Checkout redirects to after a hosted payment.
 *   /payment-success?order=ID   → payment captured (webhook marks the order paid)
 *   /payment-cancelled?order=ID → customer backed out; order stays unpaid
 */
const PaymentResult = () => {
    const { t } = useTranslation();
    const [params] = useSearchParams();
    const order = params.get('order');
    const success = useLocation().pathname.includes('success');

    return (
        <div className='container-sm text-center' style={{ maxWidth: 460, padding: '48px 20px' }}>
            <div style={{ fontSize: 56 }}>{success ? '✅' : '↩️'}</div>
            <h4 className='mt-2'>{success ? t('payment.success_heading') : t('payment.cancelled_heading')}</h4>
            {success ? (
                <p className='text-muted'>
                    {order ? t('payment.success_body', { order }) : t('payment.success_body_no_order')}
                </p>
            ) : (
                <p className='text-muted'>
                    {order ? t('payment.cancelled_body', { order }) : t('payment.cancelled_body_no_order')}
                </p>
            )}
            <Link to='/' className='btn mt-2' style={{ background: '#d97757', color: '#fff', border: 'none' }}>{t('payment.back_to_start')}</Link>
        </div>
    );
};

export default PaymentResult;
